<template>
	<gc-dialog
		:title="formValues ? '更新设备组' : '新增设备组'"
		width="760px"
		:show.sync="visible"
		@close="$emit('close-modal')"
		@cancel="$emit('close-modal')"
		@ok="handleSubmitForm"
		:okLoading="requestLoading"
	>
		<el-form :model="modelForm" :rules="rules" ref="modelForm" label-position="top" label-width="100px">
			<div class="form-block">
				<el-row :gutter="12">
					<el-col :span="24">
						<el-form-item label="设备组名称" prop="deviceGroupName">
							<el-input
								size="small"
								v-model="modelForm.deviceGroupName"
								disabled
								placeholder="请输入"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="运营商平台" prop="platformId">
							<el-select v-model="modelForm.platformId" placeholder="请选择" @change="setDeviceGroupName">
								<el-option
									v-for="item in platformProductOptions"
									:key="item.platformId"
									:label="item.platformName"
									:value="item.platformId"
									:disabled="item.status === 0"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="设备类型" prop="deviceTypeId">
							<el-select
								v-model="modelForm.deviceTypeId"
								placeholder="请选择"
								filterable
								@change="setDeviceGroupName"
							>
								<el-option
									v-for="item in deviceTypeListOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="业务系统" prop="businessSystem">
							<el-select
								v-model="modelForm.businessSystem"
								placeholder="请选择"
								@change="setDeviceGroupName"
							>
								<el-option
									v-for="item in bizSysTypeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注" prop="remarks" style="margin-bottom: 6px">
							<el-input
								type="textarea"
								v-model="modelForm.remarks"
								placeholder="请输入备注"
								:rows="3"
								resize="none"
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-col :span="24">
					<div class="permission-desc-title">权限说明</div>
					<p class="desc-item">1. 编辑权限：当前登录账号所属单位下的员工可编辑</p>
					<p class="desc-item">
						2. 使用权限：根据所属单位，租户账号可使用所有设备组，厂商账号仅可使用自己厂商的设备组
					</p>
				</el-col>
			</div>
		</el-form>
	</gc-dialog>
</template>

<script>
import {
	apiGetPlatformProductPageList,
	apiCreateDeviceGroup,
	apiUpdateDeviceGroup,
} from '@/apis/communicationModelManage.api'
import { ruleRequired, ruleMaxLength } from '@/utils/rules'
export default {
	props: {
		deviceTypeListOptions: {
			type: Array,
			default: () => [],
		},
		manufacturerListOptions: {
			type: Array,
			default: () => [],
		},
		formValues: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			visible: true,
			modelForm: {
				deviceGroupName: null,
				platformId: null,
				deviceTypeId: null,
				businessSystem: null,
				remarks: null,
			},
			rules: {
				deviceGroupName: [ruleRequired(), ruleMaxLength(100)],
				platformId: [ruleRequired('请选择')],
				deviceTypeId: [ruleRequired('请选择')],
				businessSystem: [ruleRequired('请选择')],
				remarks: [ruleMaxLength(200)],
			},
			requestLoading: false,
			platformProductOptions: [],
		}
	},
	created() {
		this.queryPlatformProductOptions()
	},

	methods: {
		updateFormValuesSet() {
			if (this.formValues) {
				const {
					deviceGroupCode,
					id,
					deviceGroupName,
					platformId,
					deviceTypeId,
					businessSystem,
					remarks,
				} = this.formValues
				Object.assign(this.modelForm, {
					deviceGroupCode,
					id,
					deviceGroupName,
					platformId: Number(platformId),
					deviceTypeId,
					businessSystem,
					remarks,
				})
			}
		},

		async queryPlatformProductOptions() {
			const data = await apiGetPlatformProductPageList({
				current: 1,
				size: 10000,
				manufacturerId: this.manufacturerId,
			})
			this.platformProductOptions = (data.records || []).sort((x, y) => y.status - x.status)
			this.updateFormValuesSet()
		},

		handleSubmitForm() {
			this.$refs.modelForm.validate(async valid => {
				if (valid) {
					this.requestLoading = true
					try {
						const API = this.formValues ? apiUpdateDeviceGroup : apiCreateDeviceGroup
						await API({
							...this.modelForm,
							manufacturerId: this.manufacturerId,
						})
						this.$message.success('操作成功')
						this.$emit('close-modal', true)
					} finally {
						this.requestLoading = false
					}
				}
			})
		},

		setDeviceGroupName() {
			const platform = this.platformProductOptions.find(m => m.platformId === this.modelForm.platformId)
			const bizSysType = this.bizSysTypeOptions.find(m => m.value === this.modelForm.businessSystem)
			const deviceType = this.deviceTypeListOptions.find(m => m.value === this.modelForm.deviceTypeId)
			const platformTypeName = platform?.platformType || ''
			const bizSysTypeName = bizSysType?.label || ''
			const deviceTypeName = deviceType?.label || ''
			this.modelForm.deviceGroupName = `${platformTypeName}_${this.tenantName}_${bizSysTypeName}_${this.manufacturerName}_${deviceTypeName}`
		},
	},

	computed: {
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		tenantName() {
			return this.$store.getters.userInfo.tenantName || null
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},

		manufacturerName() {
			return this.$store.getters.userInfo.manufacturerName
		},

		bizSysTypeOptions() {
			return (this.$store.getters.dataList?.bizSysType || []).map(m => {
				return {
					label: m.name,
					value: m.defaultValue,
				}
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.form-block {
	& + .form-block {
		margin-top: 12px;
	}
	.title {
		font-size: 17px;
		margin-bottom: 8px;
		color: #000;
		display: flex;
		justify-content: space-between;
		span {
			font-size: 14px;
			color: #4d6bff;
			cursor: pointer;
			user-select: none;
		}
	}

	.permission-desc-title {
		color: #333;
		line-height: 24px;
		margin: 6px 0;
	}
	.desc-item {
		color: #999;
		line-height: 20px;
	}
}
</style>
